export default __webpack_public_path__ + "79553275a0376dff5b81b3520518629a.png";